import {checkIfUserHasRole} from "@/core/utils/helpers/checkIfUserHasRole";

function navigationShouldBeIntercepted(to, store = $store) {

    if (to.matched.some(record => record.meta.showToManager)
        && checkIfUserHasRole(constants.user_role.MANAGER, store.state.currentUser)) {
        return false;
    }

    if (to.matched.some(record => record.meta.onlyIfOfferingServices)) {
        return !(
            checkIfUserHasRole(constants.user_role.OFFERING_SERVICES, store.state.currentUser)
            || checkIfUserHasRole(constants.user_role.VENUE, store.state.currentUser)
        )
    }

    if (to.matched.some(record => record.meta.onlyIfSeekingServices)) {
        return !checkIfUserHasRole(constants.user_role.SEEKING_SERVICES, store.state.currentUser)
    }

    if (to.matched.some(record => record.meta.onlyVipPunter)) {
        const isVip = _.get(store, 'state.currentUser.is_vip', false);
        const isPunter = checkIfUserHasRole(constants.user_role.SEEKING_SERVICES, store.state.currentUser);

        if (!isVip || !isPunter) {
            showNotVipModal();
            return true;
        }
    }

    if (to.matched.some(record => record.meta.onlyIfOfferingOrSeekingServices)) {

        if (checkIfUserHasRole(constants.user_role.SEEKING_SERVICES, store.state.currentUser)) {
            return false;
        }

        if (checkIfUserHasRole(constants.user_role.OFFERING_SERVICES, store.state.currentUser)) {
            return false;
        }

        if (checkIfUserHasRole(constants.user_role.VENUE, store.state.currentUser)) {
            return false;
        }

        return true;
    }

    return false;

}

function showNotVipModal() {
    const modalId = '#navigationNotVip';
    if (typeof $(modalId).modal === "function") {
        $(modalId).modal('show');
    }
}

export default navigationShouldBeIntercepted;
